import groq from 'groq';

import { PRODUCT_IN_BLOCK } from '../product';

export const PRODUCT_BLOCK = groq`
  _type == 'timeline_productBlock' => {
    ${PRODUCT_IN_BLOCK}
  }
`;
